import type { ReactNode } from 'react';
interface SectionHeadingProps {
  children: ReactNode;
}
export const SectionHeading = ({
  children
}: SectionHeadingProps) => <h4 className="font-heading font-semibold text-base text-gray-950 tracking-tightest! md:text-lg 2xl:text-xl dark:text-white" data-sentry-component="SectionHeading" data-sentry-source-file="SectionHeading.tsx">
    {children}
  </h4>;